/**
 * Replaces a part of the pathname by segmenting the parameters and inserting a new value.
 * Returns the initial endpoint if the old segment cannot be found.
 * @param endpoint Endpoint
 * @param oldSegment Part in path to replace
 * @param newSegment New part in path
 * @returns Endpoint with updated path if old segment exists, otherwise initial endpoint.
 */
export const replacePathSegment = (endpoint, oldSegment, newSegment) => {
    let url;
    try {
        url = new URL(endpoint);
    }
    catch {
        throw new Error(`Invalid absolute URL: ${endpoint}`);
    }
    const segments = url.pathname.split('/').filter(Boolean);
    const segmentIndex = segments.indexOf(oldSegment);
    if (segmentIndex === -1)
        return endpoint;
    segments.splice(segmentIndex, 1, ...newSegment.map(encodeURIComponent));
    url.pathname = '/' + segments.join('/');
    return url.toString();
};
//# sourceMappingURL=pathUtils.js.map